import {VOLLEYNET_TABLE_URL} from '../config';
import {TableRow} from '../types';

export async function fetchTable(bewId: string): Promise<TableRow[]> {
    const response = await fetch(`${VOLLEYNET_TABLE_URL}?action=tabelle&bew_id=${encodeURIComponent(bewId)}`);
    if (!response.ok) {
        throw new Error(`volleynet answered ${response.status} for bew_id ${bewId}`);
    }
    return parseTableXml(await response.text());
}

/**
 * Parses the volleynet table XML, sorted by rank. For unknown competitions volleynet answers
 * with HTTP 200 and a PHP error inside the <xml> root, which simply yields no rows.
 */
export function parseTableXml(xml: string): TableRow[] {
    const doc = new DOMParser().parseFromString(xml, 'text/xml');

    return Array.from(doc.getElementsByTagName('tabelle'), row => {
        const field = (tag: string) => row.getElementsByTagName(tag)[0]?.textContent?.trim() ?? '';
        return {
            name: field('tea_name'),
            position: Number(field('posdirekt')) || 0,
            points: field('punkte'),
            played: field('gespielt'),
            won: field('gewonnen'),
            lost: field('verloren'),
        };
    }).sort((a, b) => a.position - b.position);
}
